import React, { useContext, useEffect } from 'react';
import { useViewState } from '../contexts/ViewState';
import { MapContext } from 'components/maps';
import { PREFERENCE_KEYS } from 'types/preferenceTypes';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface MapSessionProps {}

const MapSession: React.FunctionComponent<MapSessionProps> = () => {
  const { selectedLayers } = useContext(MapContext);
  const viewState = useViewState();
  useEffect(() => {
    if (!Object.values(viewState)) {
      return;
    }

    sessionStorage.setItem(
      PREFERENCE_KEYS.MAP_CONFIG_SESSION_KEY,
      JSON.stringify({
        viewState,
        layers: selectedLayers,
      })
    );
  }, [viewState, selectedLayers]);

  return null;
};

export default MapSession;
